import React from "react";

const ColorsView = ({ url }) => {
  return (
    <div className="flex gap-1 mt-1 w-full">
      MORE COLOURS
    </div>
  );
};

export const HoverColorsView = ({ url }) => {
  return (
    <div
      className="hidden md:flex absolute gap-1 mt-2 w-full justify-center transform translate-y-[70px] transition-all duration-200 ease-linear opacity-0
        group-hover:opacity-100 group-hover:translate-y-5 z-[1]"
    >
      More Colours Available
    </div>
  );
};

export default ColorsView;
